export const sectionHeader = (title, isSubHeader) => {
  const leftMargin = isSubHeader ? 44 : 0;
  const topMargin = isSubHeader ? 20 : 10;

  const x2 = isSubHeader ? 470 : 520
  return ({
    style: "sectionHeader",
    margin: [leftMargin, topMargin, 0, 10],
    stack: [
        { text: title, style: "label", margin: [0, 0, 0, 5] },
        {
    	    canvas: [
    				{
    					type: 'line',
    					x1: 0, y1: 0,
    					x2: x2, y2: 0,
    					lineWidth: 2,
    					lineCap: 'round',
    					lineColor: "#8493a3",
    				},

    			]
        },
    ]
  });
}



// WEBPACK FOOTER //
// ./src/store/generators/PDF/bid/sectionHeader.js